import { motion } from "framer-motion";
import { FiArrowRight, FiCheckCircle, FiTrendingUp } from "react-icons/fi";
import { Link } from "react-router-dom";
import { topWebsites } from "../../data/fakeData";
import SitePreview from "../UI/SitePreview";
import StarRating from "../UI/StarRating";

const TopWebsites = () => (
  <section className="section-tinted">
    <div className="container-main py-20 lg:py-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12"
      >
        <div>
          <div className="accent-line" style={{ backgroundColor: "#d97706" }} />
          <p className="label-tag mb-2" style={{ color: "#d97706" }}>
            Community Rankings
          </p>
          <h2 className="section-title">Top Rated Websites</h2>
          <p className="section-subtitle">
            Ranked by our community of reviewers — the highest rated picks.
          </p>
        </div>
        <Link to="/top-50" className="btn-ghost flex-shrink-0">
          See full Top 50 <FiArrowRight size={14} />
        </Link>
      </motion.div>

      <div className="card shadow-lg shadow-slate-200/40 overflow-hidden">
        <div className="hidden lg:grid grid-cols-[4rem_1fr_7rem_7rem_5rem] gap-4 px-6 py-3 bg-slate-50 border-b-2 border-slate-100">
          {["Rank", "Website", "Rating", "Category", "Monthly Visits"].map(
            (h) => (
              <span
                key={h}
                className="text-[10px] font-bold uppercase tracking-widest text-slate-400"
              >
                {h}
              </span>
            ),
          )}
        </div>

        {topWebsites.slice(0, 10).map((site, i) => (
          <motion.div
            key={site.id}
            initial={{ opacity: 0, x: -15 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.04 }}
          >
            <Link
              to={`/website/${site.id}`}
              className="group grid grid-cols-[3rem_1fr_auto] lg:grid-cols-[4rem_1fr_7rem_7rem_5rem] gap-3 lg:gap-4 items-center px-5 lg:px-6 py-4 border-b border-slate-100 last:border-0 hover:bg-indigo-50/40 transition-colors"
            >
              <div className="flex items-center justify-center">
                <span
                  className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm font-extrabold ${
                    i === 0
                      ? "bg-amber-100 text-amber-700 ring-2 ring-amber-200"
                      : i === 1
                        ? "bg-slate-100 text-slate-600 ring-2 ring-slate-200"
                        : i === 2
                          ? "bg-orange-50 text-orange-600 ring-2 ring-orange-200"
                          : "bg-slate-50 text-slate-500"
                  }`}
                >
                  {site.globalRank}
                </span>
              </div>
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-11 h-11 rounded-xl overflow-hidden flex-shrink-0 ring-2 ring-slate-100">
                  <SitePreview
                    url={site.url}
                    alt={site.name}
                    className="w-full h-full"
                  />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <span className="font-bold text-slate-900 text-sm group-hover:text-indigo-600 transition-colors truncate">
                      {site.name}
                    </span>
                    {site.verified && (
                      <FiCheckCircle
                        size={13}
                        className="text-indigo-500 flex-shrink-0"
                      />
                    )}
                  </div>
                  <p className="text-xs text-slate-400 font-medium truncate mt-0.5 hidden sm:block">
                    {site.description}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <StarRating rating={site.rating} size="xs" />
                <span className="text-sm font-extrabold text-slate-900">
                  {site.rating}
                </span>
              </div>
              <span className="badge-blue hidden lg:inline-flex">
                {site.category}
              </span>
              <span className="text-sm font-bold text-slate-600 hidden lg:block">
                {site.monthlyVisits}
              </span>
            </Link>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-center mt-8"
      >
        <Link to="/top-50" className="btn-primary">
          <FiTrendingUp size={15} /> View Complete Top 50
        </Link>
      </motion.div>
    </div>
  </section>
);

export default TopWebsites;
